import { preserveSearchParams } from '@namespace/helpers';

export const createCategoryItemPath = ({
  basePath,
  categoryId,
  isActive,
  search
}: {
  basePath: string;
  categoryId: string;
  isActive: boolean;
  search: string;
}) => {
  const path = `${basePath}/${categoryId}`;

  if (!isActive) {
    return path;
  }

  const searchParams = preserveSearchParams(['timeFilter'], search);

  return searchParams ? `${path}?${searchParams}` : path;
};
